import { render, staticRenderFns } from "./Widget.vue?vue&type=template&id=4938aa2c&scoped=true"
import script from "./Widget.vue?vue&type=script&lang=js"
export * from "./Widget.vue?vue&type=script&lang=js"
import style0 from "./Widget.vue?vue&type=style&index=0&id=4938aa2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4938aa2c",
  null
  
)

export default component.exports